import { AxiosService } from '../../axios/axios.service';
import { tAxiosCustomConfig } from '../../axios/axios.types';
import { tFunnelStage, tFunnelsWithStages } from '../../pages/Pipe/Pipe.types';
import {
  tAdvanceSearchModalResponse,
  tGetLeadsQueryParams,
  tGetLeadsResponse,
} from './AdvanceSearchModal.types';

export const AdvanceSearchModalService = {
  getLeads: async function (
    currentWorkspaceId: string,
    queryParams?: tGetLeadsQueryParams,
    path: string = 'filter',
  ): Promise<tAdvanceSearchModalResponse<tGetLeadsResponse>> {
    try {
      const config: tAxiosCustomConfig = {
        params: queryParams,
      };

      const response = await AxiosService.get<
        tAdvanceSearchModalResponse<tGetLeadsResponse>
      >(`/workspace/${currentWorkspaceId}/leads/${path}`, config);

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  getWorkspaceFunnels: async function (
    workspaceId: string,
  ): Promise<tAdvanceSearchModalResponse<{ pipes: tFunnelsWithStages[] }>> {
    try {
      const response = await AxiosService.get<
        tAdvanceSearchModalResponse<{ pipes: tFunnelsWithStages[] }>
      >(`/workspace/${workspaceId}/pipes`);

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  getFunnelStages: async function (
    workspaceId: string,
    funnelId: string,
  ): Promise<tAdvanceSearchModalResponse<{ stages: tFunnelStage[] }>> {
    try {
      const response = await AxiosService.get<
        tAdvanceSearchModalResponse<{ stages: tFunnelStage[] }>
      >(`/workspace/${workspaceId}/pipe/${funnelId}/stages`);

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
